import { styled } from '@mui/material/styles';

export const FeedbackUserData = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige2,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  marginTop: theme.spacing(3)
}));
